import {createTheme} from "@mui/material";
import '../sass/app.scss'

const GciDarkTheme = createTheme({
    components: {
        MuiTypography: {
            styleOverrides: {
                root: {
                    color: '#fff',
                },
            },
        },
        MuiInputLabel: {
            styleOverrides: {
                asterisk: {
                    '&.Mui-error': {
                        color: '#E53939'
                    },
                },
                root: {
                    '&.Mui-error': {
                        color: 'white', // Replace with your color
                    },
                    fontFamily: 'Gotham-Bold',
                    whiteSpace: 'normal',
                }
            },
            defaultProps: {
                shrink: true
            }
        },
        MuiFormLabel: {
            defaultProps: {
                sx: {
                    color: 'white',
                    minHeight: '2rem',
                }
            }
        },
        MuiOutlinedInput: {
            defaultProps: {
                sx: {
                    minHeight: '3rem',
                },
            },
            styleOverrides: {
                root: {
                    '&.Mui-error .MuiOutlinedInput-notchedOutline': {
                        borderColor: '#E53939', // Ensure error border color matches palette
                    },
                },
            },
        },
        MuiTextField: {
            defaultProps: {
                fullWidth: true,
            }
        }
    },
    palette: {
        mode: 'dark',
        primary: {
            main: '#FFFFFF',
            light: '#F3FCFF',
            dark: '#FFFFFF'
        },
        error: {
            main: '#E58989',
            light: '#E53939',
            dark: '#B40000'
        },
        success: {
            main: '#188623',
            light: '#F2FDF3',
            dark: '#13691B'
        },
        gciRed: {
            main: '#B71234',
            light: '#D3153B',
            dark: '#850D25',
            contrastText: '#fff',
        },
        glacierBlue: {
            main: '#00A9E0',
            light: '#00BFFE',
            dark: '#006384',
            contrastText: '#000',
        },
        midnightBlue: {
            main: '#042046',
            light: '#073473',
            dark: '#031835',
            contrastText: '#fff',
        },
        scale: {
            white: '#031835',
            light: '#F2F5FA',
            middle: '#BDBFC6',
            dark: '#303139',
            almost_black: '#312E3B'
        },
    },
})

// declare module '@mui/material/styles' {
//     interface Palette {
//         gciRed: Palette['primary'],
//         glacierBlue: Palette['primary'],
//         midnightBlue: Palette['primary'],
//         scale: Palette['primary'],
//     }
//
//     interface PaletteOptions {
//         gciRed: PaletteOptions['primary'],
//         glacierBlue: PaletteOptions['primary'],
//         midnightBlue: PaletteOptions['primary'],
//         scale: {
//             white: string,
//             light: string,
//             middle: string,
//             dark: string,
//             almost_black: string
//         }
//     }
//
//     interface PaletteColor {
//         darker?: string;
//     }
//
//     interface SimplePaletteColorOptions {
//         darker?: string;
//     }
// }

declare module '@mui/material/Button' {
    interface ButtonPropsColorOverrides {
        gciRed: true;
        glacierBlue: true;
        midnightBlue: true;
    }
}

export default GciDarkTheme
